import { App } from "antd";

export const useNotifications = () => {
    const { notification, modal } = App.useApp();

    const showInfo = (message) => {
        notification.info({ description: message });
    }

    const showError = (message) => {
        notification.error({ description: message });
    }

    const showSuccess = (message) => {
        notification.success({ description: message });
    }

    const confirmDelete = async (id) => {
        const ok = await modal.confirm({ content: `¿Eliminar ítem (ID: ${id}) ?` });
        return ok;
    }

    return {
        showSuccess,
        showInfo,
        showError,
        confirmDelete
    };
}